const people = [
  { name: "沈夜", role: "都市剧男主 · 深情老干部人设", risk: 93, status: "已崩", reason: "被曝私下言论与角色人设严重割裂，粉丝回踩", trend: -64 },
  { name: "白允", role: "选秀出道歌手 · 全开麦实力唱将", risk: 88, status: "已崩", reason: "舞台口型错位实锤比对，垫音比例过高", trend: -71 },
  { name: "程墨", role: "新锐导演 · 温柔讲理文化人", risk: 76, status: "崩塌中", reason: "考古旧采访言论翻车，逐条对线进行中", trend: -58 },
  { name: "苏念", role: "童星女演员 · 励志公益人设", risk: 64, status: "预警", reason: "被指抄袭公益企划，团队回应口径摇摆", trend: -42 },
  { name: "池野", role: "男团主舞 · 干净清冷少年感", risk: 57, status: "预警", reason: "与经纪人越界画面流出，等待公开回应", trend: -39 },
  { name: "顾言", role: "顶流男星 · 礼貌体贴宠粉", risk: 49, status: "观察", reason: "机场冷脸甩手，老粉大规模脱粉回踩", trend: -31 },
];

const statusStyle: Record<string, string> = {
  已崩: "bg-foreground-950 text-background-50",
  崩塌中: "bg-primary-500 text-background-50",
  预警: "bg-accent-500 text-foreground-950",
  观察: "bg-secondary-100 text-secondary-800",
};

export default function Reputation() {
  return (
    <section id="reputation" className="w-full bg-background-100/60 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex flex-col gap-3 md:mb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-1.5 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
              Collapse Radar · 口碑崩盘预警
            </p>
            <h3 className="font-display text-2xl font-black text-foreground-950 md:text-[34px] md:leading-tight">
              谁的人设正在撑不住？
            </h3>
            <p className="mt-1.5 max-w-2xl text-sm text-foreground-600">
              好感度实时下探、口碑持续崩盘中的名单。越靠前越危险，随时可能进归档，蹲住脱粉瞬间。
            </p>
          </div>
          <span className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-semibold text-secondary-700">
            <i className="ri-refresh-line"></i> 每 30 分钟校准一次
          </span>
        </div>

        <div className="overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 shadow-card">
          <ul className="divide-y divide-background-100">
            {people.map((p) => (
              <li key={p.name} className="flex flex-col gap-3 px-4 py-4 transition-colors hover:bg-background-100/50 md:px-6 lg:flex-row lg:items-center lg:gap-6">
                <div className="flex w-full shrink-0 items-center gap-3 lg:w-64">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background-100 font-display text-base font-black text-foreground-800 ring-1 ring-background-200">
                    {p.name.slice(0, 1)}
                  </span>
                  <span className="min-w-0">
                    <span className="flex items-center gap-2">
                      <span className="whitespace-nowrap text-[15px] font-bold text-foreground-950">{p.name}</span>
                      <span className={`whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold ${statusStyle[p.status]}`}>
                        {p.status}
                      </span>
                    </span>
                    <span className="mt-0.5 block truncate text-xs text-foreground-500">{p.role}</span>
                  </span>
                </div>

                <div className="hidden shrink-0 text-sm lg:block">
                  <span className="whitespace-nowrap text-xs font-semibold text-foreground-500">风险</span>
                  <span className="ml-2 font-display text-lg font-black text-primary-600">{p.risk}</span>
                  <span className="text-xs text-foreground-400">/100</span>
                </div>

                <p className="min-w-0 flex-1 text-[13px] leading-relaxed text-foreground-600">{p.reason}</p>

                <div className="flex w-full shrink-0 flex-col lg:w-52">
                  <div className="mb-1 flex items-center justify-between text-[11px]">
                    <span className="text-foreground-500">好感度</span>
                    <span className="inline-flex items-center font-bold text-primary-600">
                      <i className="ri-arrow-down-line mr-0.5"></i>
                      {p.trend}%
                    </span>
                  </div>
                  <div className="h-2 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-accent-500 via-primary-400 to-primary-600"
                      style={{ width: `${p.risk}%` }}
                    ></div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}